// import $ from 'jquery';
// import 'lity';
import lity from 'lity';

if (localStorage.getItem('modalSeen') != 'shown') {

  // Open modal after 3 seconds
  setTimeout(function() {
    lity('#industryModal'); 
  }, 3000);

  // Set cookie in localStorage
  localStorage.setItem('modalSeen','shown')
};